module.exports = __webpack_public_path__ + "static/media/surfboard.9237b5ac.svg";